export const getDemographicsSectionStyle = (_, { palette = {} }) => ({
  demographicsContainer: {
    marginBottom: 0,

    '& .panel-heading': {
      border: 'none',

      '& .panel-title': {
        margin: 0,

        '& > a': {
          color: palette.themePrimary,
          fontSize: 18,
          padding: 0,

          '&:after': {
            fontSize: 18,
            margin: '0 10px 0 0',
            padding: 0,
          },
        },
      },
    },

    '& .panel-body': {
      padding: '0 0 0 28px',

      '& .alert-info': {
        marginBottom: 0,

        '& .ms-Icon': {
          color: palette.themePrimary,
        },
      },
    },
  },
});
